/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import * as yup from 'yup'

yup.setLocale({
  mixed: {
    required: 'GENERAL_FORM_FIELD_IS_REQUIRED_ERROR'
  },
  string: {
    max: 'FORM_VALIDATION_ERROR_MAX_LENGTH_IS_${max}'
  }
})

const ValidationSchema = () => {
  return yup.object().shape({
    name: yup
      .string()
      .trim()
      .max(255)
      .required()
      .default(() => ''),
    description: yup
      .string()
      .max(255)
      .nullable()
      .default(() => ''),
    id: yup.number().nullable()
  })
}

export default ValidationSchema
